import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import { useAuth } from "../../../context/AuthContext";
import { addPortalUsers } from "../../../redux/slice/addPortalUsersSlice";
import { deactivatePortalUsers } from "../../../redux/slice/deactivatePortalUsersSlice";
import { unlockPortalUsers } from "../../../redux/slice/unlockPortalUser";
import "../../../../assets/styles/buttons.css";
import { fetchAdmin } from "../../../redux/slice/adminSlice";
import { fetchUserDetails } from "../../../redux/slice/getUserDetails";
import { updateUserPassword } from "../../../redux/slice/updateUserPassword";
import { fetchBranch } from "../../../redux/slice/getBranchData";
import { updateUserDetails } from "../../../redux/slice/updateUserDetails";
import { StyledButton } from "../style/styleComp";
import { ArrowRightOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import { trackFeatureAction } from "../../../analytics/googleAnalytics";
import {
  Spin,
  Table,
  Card,
  Modal,
  Button,
  Input,
  Tabs,
  Upload,
  message,
  Tooltip,
  Radio,
  Form,
  Row,
  Col,
  Alert,
  Typography,
  Select,
  Tag,
  Divider,
} from "antd";
import {
  UploadOutlined,
  LoadingOutlined,
  PlusOutlined,
  FileExcelOutlined,
  InfoCircleOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import * as XLSX from "xlsx";

const { Option } = Select;

// Groups an admin can assign from Modify Details. Keep in sync with USER_GROUPS in
// admin_user.py (backend), which sets group_name from the chosen group_id.
const USER_GROUPS = [
  { id: "0", name: "Leadership" },
  { id: "1", name: "Supervisor" },
  { id: "3", name: "Branch" },
  { id: "4", name: "Credit" },
  { id: "5", name: "Operations" },
  { id: "10", name: "Admin" },
  { id: "14", name: "HR" },
  { id: "19", name: "Read" },
];

// Returned by the users API for the Modify Details modal only; not shown as table columns.
const MODAL_ONLY_KEYS = ["email_id", "phone", "group_id", "group_name"];

const AddUSer = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [selectedFile, setSelectedFile] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [uploadAlert, setUploadAlert] = useState("");
  const [lastUpdatedDate, setLastUpdatedDate] = useState(null);
  const [lastUpdatedTime, setLastUpdatedTime] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [userUploadType, setUserUploadType] = useState(null);
  const [confirmationModalVisible, setConfirmationModalVisible] = useState(false);
  const [userToBeDeactivated, setUserToBeDeactivated] = useState("");
  const [branchToBeRemoved, setBranchToBeRemoved] = useState([]);
  const [userToBeUnlocked, setUserToBeUnlocked] = useState("");
  const [unlockModalVisible, setUnlockModalVisible] = useState("");
  const [activationModalVisible, setActivationModalVisible] = useState(false);
  const [userToBeActivated, setUserToBeActivated] = useState("");
  const [passwordModalVisible, setPasswordModalVisible] = useState(false);
  const [branchMapModalVisible, setBranchMapModalVisible] = useState(false);
  const [ModifyUserDetailsModalVisible, setModifyUserDetailsModalVisible] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [userID, setUserID] = useState("");
  const [userName, setUserName] = useState("");
  const [uploadFailedError, setUploadFailedError] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [policyAlert, setPolicyAlert] = useState(false);
  const [branchMappingData, setBranchMappingData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [modalPagination, setModalPagination] = useState({
    pageSize: 10,
    current: 1,
    total: branchMappingData.length,
  });
  const [branchToAssign, setBranchToAssign] = useState(null);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [mappedBranches, setMappedBranches] = useState("");
  const [branchChangeUser, setBranchChangeUser] = useState("");
  const [modifyDetailsUser, setModifyDetailsUser] = useState("");
  const [userNameToChange, setUserNameToChange] = useState("");
  const [roleToChange, setRoleToChange] = useState("");
  const [deleteConfirmationVisible, setDeleteConfirmationVisible] = useState(false);
  const [newUserName, setNewUserName] = useState("");
  const [detailType, setDetailType] = useState("");
  const [roleValue, setRoleValue] = useState("");
  const [infoModalVisible, setInfoModalVisible] = useState(false);
  const [roleChangeLoading, setRoleChangeLoading] = useState(false);
  const [emailToChange, setEmailToChange] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [phoneToChange, setPhoneToChange] = useState("");
  const [newPhone, setNewPhone] = useState("");
  const [groupToChange, setGroupToChange] = useState("");
  const [groupValue, setGroupValue] = useState(null);

  const csvHeaders = [
    { label: "USER ID", key: "userid" },
    { label: "USERNAME", key: "username" },
    { label: "EMAIL ID", key: "email_id" },
    { label: "PHONE", key: "phone" },
    { label: "BRANCH ID", key: "branch_id" },
    { label: "STATUS", key: "status" },
    { label: "ROLE", key: "role" },
    { label: "ACTION", key: "action" },
    { label: "PERFORMED BY", key: "performed_by" },
    { label: "PERFORMED AT", key: "performed_at" },
    { label: "DEACTIVATED DATE", key: "deactivation_datetime" },
    { label: "LAST LOGIN DATE", key: "last_login" },
    { label: "CREATED AT", key: "created_at" },
  ];

  var prateekKaVariable = false;

  const { authState, onLogout } = useAuth();

  var token_decoded = authState.token;
  var jwtBearer = authState.token;
  var jwt_payload = "";
  var jwt_payload_group = [];
  var jwt_payload_expiry = [];
  var jwt_payload_userid = "";
  
  if (jwtBearer) {
    jwt_payload = jwt_decode(jwtBearer);
    jwt_payload_group = jwt_payload.group_id;
    jwt_payload_expiry = jwt_payload.exp;
    jwt_payload_userid = jwt_payload.user_id;
  }

  // Session Timeout
  const TOKEN_KEY = "my-jwt";
  var currentTime = Math.floor(Date.now() / 1000);

  if (jwt_payload_expiry.length != 0) {
    if (currentTime > jwt_payload_expiry) {
      console.log("In token expired condition");
      AsyncStorage.removeItem(TOKEN_KEY);
      onLogout();
      location.reload();
    }
  }

  useEffect(() => {
    trackFeatureAction("Adminusers", "User Management", "open");
    dispatch(fetchAdmin({ jwtBearer }));
  }, []);

  const state = useSelector((state) => state);

  const allFields = state.admin.data?.message || [];

  let objectsArray = [];
  if (Array.isArray(allFields)) {
    objectsArray = allFields.map((user) => {
      const obj = { ...user };
      if (user.audit_trail) {
        obj["action"] = user.audit_trail.action && user.audit_trail.field 
          ? `${user.audit_trail.action} ( ${user.audit_trail.field} )` 
          : user.audit_trail.action;
        
        let perfAt = user.audit_trail.performed_at;
        if (perfAt) {
          const date = new Date(perfAt);
          date.setMinutes(date.getMinutes() + 330);
          const pad = (n) => n.toString().padStart(2, '0');
          perfAt = `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        }
        obj["performed_at"] = perfAt;
        obj["performed_by"] = user.audit_trail.performed_by;
      }
      return obj;
    });
  } else {
    const keys = state.admin.data
      ? Object.keys(allFields["userid"] ? allFields["userid"] : "")
      : [];

    objectsArray = keys.map((key) => {
      const obj = {};
      for (const subKey in allFields) {
        if (subKey === "audit_trail") {
          const audit = allFields[subKey][key];
          if (audit) {
            obj["action"] = audit.action && audit.field 
              ? `${audit.action} ( ${audit.field} )` 
              : audit.action;
            
            let perfAt = audit.performed_at;
            if (perfAt) {
              const date = new Date(perfAt);
              date.setMinutes(date.getMinutes() + 330);
              const pad = (n) => n.toString().padStart(2, '0');
              perfAt = `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
            }
            obj["performed_at"] = perfAt;
            obj["performed_by"] = audit.performed_by;
          }
        } else {
          obj[subKey] = allFields[subKey][key];
        }
      }
      return obj;
    });
  }

  const uniqueRoles = [...new Set(objectsArray.map((item) => item.role))];

  useEffect(() => {
    setDataSource(objectsArray);
  }, [allFields]);

  const allKeys = objectsArray.reduce((keys, record) => {
    return keys.concat(Object.keys(record));
  }, []);

  const orderedKeys = [
    "userid",
    "username",
    "email_id",
    "phone",
    "branch_id",
    "status",
    "role",
    "action",
    "performed_by",
    "performed_at",
    "deactivation_datetime",
    "last_login",
    "created_at",
    "wrong_password_attempt_count",
  ];

  const uniqueKeys = [...new Set(allKeys)].sort((a, b) => {
    const indexA = orderedKeys.indexOf(a);
    const indexB = orderedKeys.indexOf(b);
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });

  const columnTitles = {
    userid: "USER ID",
    username: "USERNAME",
    email_id: "EMAIL ID",
    phone: "PHONE",
    branch_id: "BRANCH ID",
    status: "STATUS",
    role: "ROLE",
    last_login: "LAST LOGIN DATE",
    deactivation_datetime: "DEACTIVATED DATE",
    created_at: "CREATED AT",
    action: "ACTION",
    performed_at: "PERFORMED AT",
    performed_by: "PERFORMED BY",
    wrong_password_attempt_count: "WRONG PASSWORD ATTEMPTS",
  };

  const columns = [
    ...uniqueKeys
      .filter((key) => key !== "audit_trail" && !MODAL_ONLY_KEYS.includes(key))
      .map((key) => ({
        title: <strong>{columnTitles[key] || key.toUpperCase().replace(/_/g, " ")}</strong>,
        dataIndex: key,
        key: key,
        width: 150,
        align: "left",
        filters: [...new Set(objectsArray.map((record) => record[key]))].map(
          (value) => ({
            text: value,
            value: value,
          })
        ),
        onFilter: (value, record) => record[key] === value,
        filterSearch: true,
      })),
    {
      title: <strong>UNLOCK ACCOUNT</strong>,
      dataIndex: "unlockAccount",
      key: "unlockAccount",
      width: "20%",
      align: "left",
      render: (text, record) => {
        if (record.wrong_password_attempt_count > 2) {
          return (
            <a
              style={{ color: "dodgerBlue" }}
              onClick={() => handleUnlock(record)}
            >
              Unlock
            </a>
          );
        }
        return null;
      },
    },
    {
      title: <strong>ACTIVATE/DEACTIVATE</strong>,
      dataIndex: "status",
      key: "status",
      width: "20%",
      align: "left",
      render: (text, record) => {
        if (text === "Active") {
          return (
            <a
              style={{ color: "red" }}
              onClick={() => handleDeactivate(record)}
            >
              Deactivate
            </a>
          );
        } else if (text === "Inactive") {
          return (
            <a
              style={{ color: "dodgerBlue" }}
              onClick={() => handleActivate(record)}
            >
              Activate
            </a>
          );
        } else {
          return null;
        }
      },
    },
    {
      title: <strong>CHANGE BRANCH</strong>,
      dataIndex: "changeBranch",
      key: "changeBranch",
      width: "20%",
      align: "left",
      render: (text, record) => {
        return (
          <a
            style={{ color: "dodgerblue" }}
            onClick={() => handleModifyBranchMap(record)}
          >
            Modify Branch
          </a>
        );
      },
    },
    {
      title: <strong>MODIFY DETAILS</strong>,
      dataIndex: "changeDetails",
      key: "changeDetails",
      width: "20%",
      align: "left",
      render: (text, record) => {
        return (
          <a
            style={{ color: "dodgerblue" }}
            onClick={() => handleModifyUserDetails(record)}
          >
            Modify Details
          </a>
        );
      },
    },
  ];

  const branchMappingColumns = [
    {
      title: "Branch ID",
      dataIndex: "branchId",
      key: "branchId",
    },
    {
      title: <strong>REMOVE BRANCH</strong>,
      dataIndex: "removeBranch",
      key: "removeBranch",
      width: "20%",
      align: "left",
      render: (text, record) => {
        return (
          <a
            style={{ color: "dodgerBlue" }}
            onClick={() => handleDeleteBranch(record)}
          >
            Delete
          </a>
        );
      },
    },
  ];

  const allowedExtensions = ["xlsx"];

  const handleFileChange = (info) => {
    const fileExtension = info.file.name.split(".").pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      message.error(
        `Invalid file format. Allowed formats: ${allowedExtensions.join(", ")}`
      );
      return;
    }
    setFileList(info.fileList);
  };

  const handleUpload = async () => {
    console.log('In handle upload')
    setButtonLoading(true);
    if (fileList.length > 0) {
      const file = fileList[0].originFileObj;
      const reader = new FileReader();

      reader.onload = async (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const excelData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          const headers = excelData[0];
          console.log('Excel data - ', excelData)

          const formattedData = excelData.slice(1).map((row) => {
            const obj = {};
            headers.forEach((header, index) => {
              obj[header] = row[index].toString();
            });
            return obj;
          });

          const jsonString = JSON.stringify(formattedData);
          const fileSizeInBytes = new Blob([jsonString]).size;
          const fileSizeInKB = fileSizeInBytes / 1024;
          const fileSizeInMB = Math.floor(fileSizeInKB / 1024);
          const chunkNumber = parseInt(fileSizeInMB + 1);
          const chunkSize = Math.ceil(formattedData.length / chunkNumber);
          const chunks = [];
          
          for (let i = 0; i < formattedData.length; i += chunkSize) {
            chunks.push(formattedData.slice(i, i + chunkSize));
          }

          for (let i = 0; i < chunks.length; i++) {
            const response = await dispatch(
              addPortalUsers({
                jwt_token: authState.token,
                requestBody: JSON.stringify(chunks[i]),
              })
            );
          }
          trackFeatureAction(
            "Adminusers",
            "User Management",
            "upload"
          );
          message.success("File uploaded successfully");
          setLoading(false);
          setButtonLoading(false);
          setFileList([]);
        } catch (error) {
          console.error("Error:", error);
          message.error("File upload failed");
          setButtonLoading(false);
        }
      };

      reader.readAsArrayBuffer(file);
    }
    setUserUploadType(null);
  };

  const customRequest = ({ file, onSuccess }) => {
    onSuccess("ok");
  };

  const handleInfoClick = async () => {
    setInfoModalVisible(true);
  };

  const paginationOptions = {
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "100"],
    defaultPageSize: 10,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  };

  const handleDeactivate = async (record) => {
    prateekKaVariable = true;
    setConfirmationModalVisible(true);
    setUserToBeDeactivated(record.userid);
    setTimeout(() => {
      prateekKaVariable = false;
    }, 1000);
  };

  const handleModifyBranchMap = async (record) => {
    prateekKaVariable = true;
    setBranchMapModalVisible(true);
    setTimeout(() => {
      prateekKaVariable = false;
    }, 1000);

    setBranchChangeUser(record.userid);

    const branchResponse = await dispatch(
      fetchUserDetails({ jwtBearer, emp_code: record.userid })
    );
    const allBranchResponse = await dispatch(fetchBranch({ jwtBearer }));
    const branches = branchResponse?.payload?.message?.branch_id;
    console.log("branches", branches);
    setMappedBranches(branchResponse.payload?.message);
    setBranchData(allBranchResponse.payload?.message.btrim);

    if (branches) {
      const branchIds = branches
        .slice(1, -1)
        .split(",")
        .map((id) => id.trim());
      const branchData = branchIds.map((id) => ({ key: id, branchId: id }));
      setBranchMappingData(branchData);
    }
  };

  const handleModifyUserDetails = async (record) => {
    prateekKaVariable = true;
    setModifyUserDetailsModalVisible(true);
    setTimeout(() => {
      prateekKaVariable = false;
    }, 1000);

    setModifyDetailsUser(record.userid);
    setUserNameToChange(record.username);
    setRoleToChange(record.role);
    setEmailToChange(record.email_id || "");
    setPhoneToChange(record.phone || "");
    setGroupToChange(
      record.group_id ? `${record.group_id} - ${record.group_name || ""}` : ""
    );
    // Reset states when opening modal
    setDetailType(null);
    setRoleValue(null);
    setNewUserName("");
    setNewEmail("");
    setNewPhone("");
    setGroupValue(null);
  };

  const handleActivate = async (record) => {
    prateekKaVariable = true;
    setActivationModalVisible(true);
    setUserToBeActivated(record.userid);
    setTimeout(() => {
      prateekKaVariable = false;
    }, 1000);
  };

  const handleDeactivateFinal = async () => {
    const response = await dispatch(
      deactivatePortalUsers({
        jwt_token: authState.token,
        type: "Deactivate",
        requestBody: userToBeDeactivated,
      })
    );
      if (response?.payload?.code === 200) {
        trackFeatureAction(
          "Adminusers",
          "User Management",
          "deactivate"
        );
      }
    setConfirmationModalVisible(false);
    dispatch(fetchAdmin({ jwtBearer: authState.token }));
  };

  const handleActivateFinal = async () => {
    const response = await dispatch(
      deactivatePortalUsers({
        jwt_token: authState.token,
        type: "Activate",
        requestBody: userToBeActivated,
      })
    );
    trackFeatureAction(
      "Adminusers",
      "User Management",
      "activate"
    );
    setActivationModalVisible(false);
    dispatch(fetchAdmin({ jwtBearer: authState.token }));
  };

  const handleUnlock = async (record) => {
    prateekKaVariable = true;
    setUnlockModalVisible(true);
    setUserToBeUnlocked(record.userid);
    setTimeout(() => {
      prateekKaVariable = false;
    }, 1000);
  };

  const handleUnlockFinal = async () => {
    const userid = userToBeUnlocked;
    dispatch(unlockPortalUsers({ jwt_token: authState.token, userid }));
    trackFeatureAction(
      "Adminusers",
      "User Management",
      "unlock");
    setUnlockModalVisible(false);
    dispatch(fetchAdmin({ jwtBearer: authState.token }));
  };

  const handleModalClose = () => {
    setConfirmationModalVisible(false);
    setActivationModalVisible(false);
    setUserID(undefined);
    setUserName(undefined);
    setNewPassword(undefined);
    form.resetFields();
    form.setFieldsValue({
      userID: undefined,
      userName: undefined,
      newPassword: undefined,
    });
    setPasswordModalVisible(false);
    setUnlockModalVisible(false);
    setBranchMapModalVisible(false);
    setDeleteConfirmationVisible(false);
    setSelectedBranches([]);
    setModifyUserDetailsModalVisible(false);
    setNewUserName("");
    setDetailType(null);
    setRoleValue(null);
    setNewEmail("");
    setNewPhone("");
    setGroupValue(null);
  };

  const onRowClick = async (record) => {
    if (prateekKaVariable == false) {
      setUserID(undefined);
      setUserName(undefined);
      setNewPassword(undefined);
      form.setFieldsValue({
        userID: undefined,
        userName: undefined,
        newPassword: undefined,
      });
      setUserID(record.userid);
      setUserName(record.username);
      setPasswordModalVisible(true);
      trackFeatureAction("Adminusers", "Reset Password", "open");
    }
  };

  const handlePasswordChange = (e) => {
    const password = e.target.value;
    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,30}$/;
    if (!strongPasswordRegex.test(password)) {
      setPolicyAlert(false);
    } else {
      setPolicyAlert(true);
    }
    setNewPassword(e.target.value);
  };

  const handleResetPassword = async () => {
    try {
      const requestBody = {
        userid: userID,
        new_password: newPassword,
        old_password: "None",
        category: "admin",
      };

      const response = await dispatch(
        updateUserPassword({ jwt_token: authState.token, requestBody })
      ).unwrap();

      if (response.code == 200) {
        form.resetFields();
        setPasswordModalVisible(false);
        trackFeatureAction(
          "Adminusers",
          "Reset Password",
          "submit"
        );
        message.success("Password changed successfully");
      } else {
        message.error(response.message);
      }
    } catch (error) {
      console.error("Error in change password:", error);
      message.error("Unknown error occurred while changing password");
    }
  };

  const handleSelectChange = (value) => {
    if (!selectedBranches.includes(value)) {
      setSelectedBranches([...selectedBranches, value]);
    }
  };

  const handleRemoveBranch = (branch) => {
    setSelectedBranches(selectedBranches.filter((item) => item !== branch));
  };

  const handleAssignBranch = () => {
    const requestBody = {
      type: "Add Branch",
      user_id: branchChangeUser,
      field_to_update: selectedBranches,
    };

    dispatch(updateUserDetails({ jwtBearer, requestBody }))
      .then((response) => {
        if (response.payload.code === 200) {
          trackFeatureAction(
            "Adminusers",
            "Branch Mapping",
            "assign"
          );
          setBranchMapModalVisible(false);
          setSelectedBranches([]);
          message.success("Branch allocated successfully");
          dispatch(fetchAdmin({ jwtBearer: authState.token }));
        } else {
          message.error("Branch allocation failed");
        }
      })
      .catch((error) => {
        message.error("Branch allocation failed");
        console.error("Error updating reschedule date:", error);
      });
  };

  const handleChangeUsername = async () => {
    if (!newUserName || newUserName.trim() === "") {
      message.warning("Please enter a new username");
      return;
    }

    setButtonLoading(true);
    
    try {
      const requestBody = {
        type: "Change Name",
        user_id: modifyDetailsUser,
        field_to_update: [newUserName],
      };

      const response = await dispatch(
        updateUserDetails({ jwtBearer, requestBody })
      ).unwrap();

      if (response.code === 200) {
        trackFeatureAction(
          "Adminusers",
          "Modify User Details",
          "change_username"
        );
        setModifyUserDetailsModalVisible(false);
        setSelectedBranches([]);
        setNewUserName("");
        setDetailType(null);
        message.success("Username changed successfully");
        await dispatch(fetchAdmin({ jwtBearer: authState.token }));
      } else {
        message.error(response.message || "Username change failed");
      }
    } catch (error) {
      console.error("Error updating username:", error);
      message.error(error.response?.data?.message || "Username change failed");
    } finally {
      setButtonLoading(false);
    }
  };

  const handleDeleteBranch = async (record) => {
    prateekKaVariable = true;
    setDeleteConfirmationVisible(true);
    setBranchToBeRemoved([record.branchId]);
    setTimeout(() => {
      prateekKaVariable = false;
    }, 1000);
  };

  const handleDeleteBranchFinal = () => {
    const requestBody = {
      type: "Remove Branch",
      user_id: branchChangeUser,
      field_to_update: branchToBeRemoved,
    };

    dispatch(updateUserDetails({ jwtBearer, requestBody }))
      .then((response) => {
        if (response.payload.code === 200) {
          trackFeatureAction(
            "Adminusers",
            "Branch Mapping",
            "remove"
          );
          setBranchMapModalVisible(false);
          setSelectedBranches([]);
          message.success("Branch removed successfully");
          setDeleteConfirmationVisible(false);
          setSelectedBranches([]);
          dispatch(fetchAdmin({ jwtBearer: authState.token }));
        } else {
          message.error("Failed to remove branch");
        }
      })
      .catch((error) => {
        console.error("Failed to remove branch - ", error);
        message.error("Failed to remove branch");
      });
  };

  const handleModalCloseDelete = () => {
    setDeleteConfirmationVisible(false);
    setBranchToBeRemoved([]);
  };

  const handleDetailTypeChange = (e) => {
    setDetailType(e.target.value);
    // Reset the other fields when changing type
    setNewUserName("");
    setRoleValue(null);
    setNewEmail("");
    setNewPhone("");
    setGroupValue(null);
  };

  // Shared submit for the email and group changes in Modify Details.
  const submitUserDetail = async (type, value, gaAction, successMessage) => {
    setButtonLoading(true);
    try {
      const requestBody = {
        type,
        user_id: modifyDetailsUser,
        field_to_update: [value],
      };

      const response = await dispatch(
        updateUserDetails({ jwtBearer, requestBody })
      ).unwrap();

      if (response.code === 200) {
        trackFeatureAction("Adminusers", "Modify User Details", gaAction);
        setModifyUserDetailsModalVisible(false);
        setDetailType(null);
        setNewEmail("");
        setNewPhone("");
        setGroupValue(null);
        message.success(successMessage);
        await dispatch(fetchAdmin({ jwtBearer: authState.token }));
      } else {
        message.error(response.message || `${type} failed`);
      }
    } catch (error) {
      console.error(`Error in ${type}:`, error);
      message.error(`${type} failed`);
    } finally {
      setButtonLoading(false);
    }
  };

  const handleChangeEmail = () => {
    const email = newEmail.trim();
    if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email)) {
      message.warning("Please enter a valid email ID");
      return;
    }
    submitUserDetail("Change Email", email, "change_email", "Email changed successfully");
  };

  const handleChangePhone = () => {
    const phone = newPhone.replace(/\s/g, "");
    if (!/^[6-9][0-9]{9}$/.test(phone)) {
      message.warning("Please enter a valid 10-digit mobile number");
      return;
    }
    submitUserDetail("Change Phone", phone, "change_phone", "Phone number changed successfully");
  };

  const handleChangeGroup = () => {
    if (!groupValue) {
      message.warning("Please select a group");
      return;
    }
    submitUserDetail("Change Group", groupValue, "change_group", "Group changed successfully");
  };

  // FIXED: Complete handleChangeRole function
  const handleChangeRole = async () => {
    // Validate role selection
    if (!roleValue) {
      message.warning("Please select a role");
      return;
    }

    setRoleChangeLoading(true);

    try {
      const requestBody = {
        type: "Change Role",
        user_id: modifyDetailsUser,
        field_to_update: [roleValue],
      };

      console.log("Changing role with request:", requestBody);
      console.log("Using token:", jwtBearer);

      const response = await dispatch(
        updateUserDetails({ 
          jwtBearer, 
          requestBody 
        })
      ).unwrap();

      console.log("Role change response:", response);

      if (response.code === 200) {
        trackFeatureAction(
          "Adminusers",
          "Modify User Details",
          "change_role"
        );
        // Close modal and reset states
        setModifyUserDetailsModalVisible(false);
        setDetailType(null);
        setRoleValue(null);
        setSelectedBranches([]);
        message.success("Role changed successfully");
        
        // Refresh the users list
        await dispatch(fetchAdmin({ jwtBearer: authState.token }));
      } else {
        message.error(response.message || "Role change failed");
      }
    } catch (error) {
      console.error("Error changing role:", error);
      // More detailed error message
      const errorMessage = error.response?.data?.message || 
                          error.message || 
                          "Failed to change role. Please try again.";
      message.error(errorMessage);
    } finally {
      setRoleChangeLoading(false);
    }
  };

  const downloadExcel = (dataSource, csvHeaders) => {
    const formattedData = dataSource.map((row) => {
      const newRow = {};
      csvHeaders.forEach((header) => {
        newRow[header.label] = row[header.key];
      });
      return newRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    
    // Create download link
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = "portal_users.xlsx";
    document.body.appendChild(link);
    link.click();
    trackFeatureAction(
      "Adminusers",
      "User Management",
      "download"
    );
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <center>
        <div>
          <Card
            style={{
              width: "60%",
              marginTop: "20px",
              boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
              borderRadius: "5px",
            }}
            bordered={true}
          >
            <center>
              <div>
                <p>
                  <strong>
                    <FileExcelOutlined /> UPLOAD USER DATA
                  </strong>
                </p>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Upload
                    customRequest={customRequest}
                    name="avatar"
                    fileList={fileList}
                    listType="picture-card"
                    onChange={handleFileChange}
                    maxCount={1}
                  >
                    {fileList.length === 0 && (
                      <div>
                        <UploadOutlined />
                        <div style={{ marginTop: 8 }}>Select File</div>
                      </div>
                    )}
                  </Upload>
                </div>

                <Button
                  className="regular-button"
                  style={{ 
                    marginTop: "20px", 
                    marginBottom: "10px", 
                    marginLeft: "10px", 
                    marginRight: "10px", 
                    backgroundColor: "red", 
                    color: "white" 
                  }}
                  onClick={handleUpload}
                  loading={buttonLoading}
                  disabled={fileList.length === 0}
                >
                  Upload
                </Button>
                <div
                  style={{
                    textAlign: "justify",
                    marginLeft: "20px",
                  }}
                >
                  <p>
                    <strong>Instructions to be followed -</strong>
                  </p>
                  <p>1. The extension of the file should be 'xlsx'.</p>
                  <p>
                    2. Name of one of the column of the excel file should
                    'Branch Name' and it should have data is this format -
                    '10001-Jobner'.
                  </p>
                  <p>
                    3. The excel sheet should not be having any formula in any
                    of the cells and cells should only have values in it.
                  </p>
                </div>

                {uploadAlert && (
                  <div style={{ marginTop: "10px" }}>{uploadAlert}</div>
                )}
              </div>
            </center>
          </Card>
          
          <Card
            style={{ width: "100%", marginTop: "20px" }}
            extra={
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <StyledButton
                  type="primary"
                  onClick={() => downloadExcel(dataSource, csvHeaders)}
                  style={{ marginRight: "25px", marginLeft: "0px" }}
                >
                  Download Report
                </StyledButton>
                <StyledButton
                  type="primary"
                  onClick={() => {trackFeatureAction("Adminusers","User Management","refresh");dispatch(fetchAdmin({ jwtBearer }));}}
                  icon={<ReloadOutlined />}
                  loading={state.admin.isLoading}
                  style={{ marginLeft: "0px" }}
                >
                  Refresh
                </StyledButton>
              </div>
            }
          >
            <div
              style={{
                overflowX: "auto",
                maxWidth: "100%",
              }}
            >
              <Table
                columns={columns}
                dataSource={dataSource}
                pagination={paginationOptions}
                bordered
                onChange={(pagination, filters) => {
                  const filterApplied = Object.values(filters || {}).some(
                    (value) =>
                      Array.isArray(value) &&
                      value.length > 0
                  );

                  if (filterApplied) {
                    trackFeatureAction(
                      "Adminusers",
                      "User Management",
                      "filter"
                    );
                  }
                }}
                rowClassName={(record, index) =>
                  index % 2 === 0
                    ? "table-row-light table-row-clickable"
                    : "table-row-dark table-row-clickable"
                }
                onRow={(record) => ({
                  onClick: () => onRowClick(record),
                })}
              />
            </div>
          </Card>
          
          {/* Deactivate Confirmation Modal */}
          <Modal
            open={confirmationModalVisible}
            onCancel={handleModalClose}
            footer={[
              <Button key="cancel" onClick={handleModalClose}>
                Cancel
              </Button>,
              <Button
                key="deactivate"
                type="primary"
                danger
                onClick={handleDeactivateFinal}
              >
                Deactivate
              </Button>,
            ]}
          >
            <p>Are you sure you want to deactivate the user?</p>
          </Modal>
          
          {/* Delete Confirmation Modal */}
          <Modal
            open={deleteConfirmationVisible}
            onCancel={handleModalCloseDelete}
            footer={[
              <Button key="cancel" onClick={handleModalCloseDelete}>
                Cancel
              </Button>,
              <Button
                key="deactivate"
                type="primary"
                danger
                onClick={handleDeleteBranchFinal}
              >
                Remove
              </Button>,
            ]}
          >
            <p>Are you sure you want to remove this branch?</p>
          </Modal>
          
          {/* Activate Confirmation Modal */}
          <Modal
            open={activationModalVisible}
            onCancel={handleModalClose}
            footer={[
              <Button key="cancel" onClick={handleModalClose}>
                Cancel
              </Button>,
              <Button
                key="deactivate"
                type="primary"
                onClick={handleActivateFinal}
              >
                Activate
              </Button>,
            ]}
          >
            <p>Are you sure you want to activate the user?</p>
          </Modal>
          
          {/* Reset Password Modal */}
          <Modal
            title={<strong>RESET PASSWORD</strong>}
            open={passwordModalVisible}
            onCancel={handleModalClose}
            footer={null}
            width={1000}
            style={{ textAlign: "center" }}
          >
            <Form
              layout="vertical"
              style={{ marginTop: "20px" }}
            >
              <Form.Item label={<strong>USER ID :</strong>}>
                <Input value={userID} style={{ color: "black" }} disabled />
              </Form.Item>
              <Form.Item label={<strong>USER NAME :</strong>}>
                <Input value={userName} style={{ color: "black" }} disabled />
              </Form.Item>
              <Form.Item label={<strong>ENTER THE NEW PASSWORD :</strong>}>
                <Input.Password
                  value={newPassword}
                  style={{ color: "#404040" }}
                  onChange={handlePasswordChange}
                />
              </Form.Item>
              {newPassword && policyAlert === true && (
                <Button
                  key="deactivate"
                  type="primary"
                  onClick={handleResetPassword}
                >
                  Reset Password
                </Button>
              )}
            </Form>
            {policyAlert === true ? null : (
              <Alert
                style={{
                  width: "60%",
                  margin: "auto",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                description="Password must contain at least 1 uppercase, 1 lowercase, 1 numeric and 1 special character(@$!%*?&). Length of the password should be 8 to 30 characters."
                type="error"
              />
            )}
          </Modal>
          
          {/* Unlock User Modal */}
          <Modal
            open={unlockModalVisible}
            onCancel={handleModalClose}
            footer={[
              <Button key="cancel" onClick={handleModalClose}>
                Cancel
              </Button>,
              <Button key="unlock" type="primary" onClick={handleUnlockFinal}>
                Unlock
              </Button>,
            ]}
          >
            <p>Are you sure you want to unlock the user?</p>
          </Modal>
          
          {/* Branch Mapping Modal */}
          <Modal
            open={branchMapModalVisible}
            onCancel={handleModalClose}
            width={1300}
            footer={null}
          >
            <div style={{ marginLeft: 15, overflowY: "auto", height: "100%" }}>
              <Row style={{ width: "100%", height: "100%" }}>
                <Col
                  flex={10}
                  style={{ marginLeft: 15, overflowY: "auto", height: "100%" }}
                >
                  <div
                    style={{
                      marginLeft: 15,
                      overflowY: "auto",
                      height: "100%",
                    }}
                  >
                    <Table
                      columns={branchMappingColumns}
                      dataSource={branchMappingData}
                      pagination={paginationOptions}
                      bordered
                      rowClassName={(record, index) =>
                        index % 2 === 0 ? "table-row-light" : "table-row-dark"
                      }
                      title={() => (
                        <Typography.Title
                          level={4}
                          style={{ textAlign: "center" }}
                        >
                          BRANCHES ASSIGNED TO SELECTED USER -{" "}
                          {branchChangeUser}
                        </Typography.Title>
                      )}
                    />
                    
                    <Form
                      style={{
                        marginLeft: "10px",
                        marginRight: "20px",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      form={form}
                      layout="vertical"
                    >
                      <Form.Item
                        label={
                          <p
                            style={{
                              fontSize: "18px",
                              color: "grey",
                              fontWeight: "500",
                            }}
                          >
                            <strong>Select branch:</strong>
                          </p>
                        }
                      >
                        <Select
                          showSearch
                          style={{
                            fontSize: "18px",
                            fontWeight: "600",
                            color: "black",
                            borderRadius: "10px",
                          }}
                          placeholder={
                            <p
                              style={{
                                fontSize: "18px",
                                fontWeight: "600",
                                borderRadius: "10px",
                              }}
                            >
                              Select a branch
                            </p>
                          }
                          optionFilterProp="children"
                          onChange={handleSelectChange}
                          filterOption={(input, option) =>
                            option.children.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {Object.entries(branchData).map(
                            ([key, branchName]) => (
                              <Option key={key} value={branchName}>
                                <p
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    color: "black",
                                    borderRadius: "10px",
                                  }}
                                >
                                  {branchName}
                                </p>
                              </Option>
                            )
                          )}
                        </Select>
                      </Form.Item>
                    </Form>

                    <div style={{ marginTop: "20px" }}>
                      {Array.isArray(selectedBranches) &&
                        selectedBranches.map((branch) => (
                          <Tag
                            key={branch}
                            closable
                            onClose={() => handleRemoveBranch(branch)}
                            style={{
                              fontSize: "18px",
                              fontWeight: "600",
                              color: "black",
                              borderRadius: "10px",
                              marginBottom: "10px",
                            }}
                          >
                            {branch}
                          </Tag>
                        ))}
                    </div>

                    <div style={{ display: "flex", justifyContent: "right" }}>
                      {selectedBranches.length > 0 && (
                        <StyledButton
                          type="primary"
                          onClick={handleAssignBranch}
                          htmlType="submit"
                          icon={<ArrowRightOutlined />}
                          style={{ marginRight: "8px" }}
                        >
                          Assign Branch
                        </StyledButton>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Modal>

          {/* Modify User Details Modal - FIXED VERSION */}
          <Modal
            open={ModifyUserDetailsModalVisible}
            onCancel={handleModalClose}
            width={600}
            footer={null}
            destroyOnClose={true}
          >
            <div
              style={{
                marginLeft: 15,
                overflowY: "auto",
                height: "100%",
                marginTop: "20px",
              }}
            >
              <Row style={{ width: "100%", height: "100%" }}>
                <Col
                  flex={10}
                  style={{ marginLeft: 15, overflowY: "auto", height: "100%" }}
                >
                  <div
                    style={{
                      marginLeft: 15,
                      overflowY: "auto",
                      height: "100%",
                    }}
                  >
                    <Form
                      style={{ marginLeft: "10px", marginRight: "20px" }}
                      form={form}
                      layout="vertical"
                    >
                      <p className="dispoPara">
                        <strong>Modify User Details</strong>
                      </p>
                      <Divider style={{ borderColor: "lightgrey" }} />
                      
                      <Form.Item>
                        <Radio.Group
                          onChange={handleDetailTypeChange}
                          value={detailType}
                          // Fixed 3-column grid so the 5 options line up instead of wrapping unevenly.
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3, 1fr)",
                            rowGap: "12px",
                            width: "100%",
                          }}
                        >
                          <Radio value="Username">
                            Change Username
                          </Radio>
                          <Radio value="Role">
                            Change Role
                          </Radio>
                          <Radio value="Email">
                            Change Email
                          </Radio>
                          <Radio value="Phone">
                            Change Phone
                          </Radio>
                          <Radio value="Group">
                            Change Group
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                      
                      <Divider />
                      
                      {detailType === "Username" && (
                        <>
                          <Form.Item
                            label={
                              <strong
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  color: "grey",
                                }}
                              >
                                Current Username
                              </strong>
                            }
                          >
                            <Input
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "black",
                                borderRadius: "10px",
                              }}
                              value={userNameToChange}
                              disabled
                            />
                          </Form.Item>
                          <Form.Item
                            label={
                              <strong
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  color: "grey",
                                }}
                              >
                                New Username
                              </strong>
                            }
                          >
                            <Input
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "black",
                                borderRadius: "10px",
                              }}
                              value={newUserName}
                              onChange={(e) => setNewUserName(e.target.value)}
                              placeholder="Enter new username"
                            />
                          </Form.Item>
                          {newUserName && (
                            <StyledButton
                              type="primary"
                              onClick={handleChangeUsername}
                              htmlType="submit"
                              icon={<ArrowRightOutlined />}
                              loading={buttonLoading}
                              style={{ marginRight: "8px" }}
                            >
                              Change Username
                            </StyledButton>
                          )}
                        </>
                      )}
                      
                      {detailType === "Role" && (
                        <>
                          <Form.Item
                            label={
                              <strong
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  color: "grey",
                                }}
                              >
                                Current Role
                              </strong>
                            }
                          >
                            <Input
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "black",
                                borderRadius: "10px",
                              }}
                              value={roleToChange}
                              disabled
                            />
                          </Form.Item>
                          <Form.Item
                            label={
                              <strong
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  color: "grey",
                                }}
                              >
                                Select New Role
                              </strong>
                            }
                          >
                            <Select
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "black",
                                borderRadius: "10px",
                                width: "100%",
                              }}
                              placeholder="Select a role"
                              value={roleValue}
                              onChange={(value) => setRoleValue(value)}
                              loading={roleChangeLoading}
                            >
                              {uniqueRoles
                                .filter((role) => role !== roleToChange)
                                .map((role, index) => (
                                  <Option key={index} value={role}>
                                    {role}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                          {roleValue && (
                            <StyledButton
                              type="primary"
                              onClick={handleChangeRole}
                              htmlType="submit"
                              icon={<ArrowRightOutlined />}
                              loading={roleChangeLoading}
                              style={{ marginRight: "8px" }}
                            >
                              Change Role
                            </StyledButton>
                          )}
                        </>
                      )}

                      {detailType === "Email" && (
                        <>
                          <Form.Item
                            label={
                              <strong
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  color: "grey",
                                }}
                              >
                                Current Email ID
                              </strong>
                            }
                          >
                            <Input
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "black",
                                borderRadius: "10px",
                              }}
                              value={emailToChange || "Not set"}
                              disabled
                            />
                          </Form.Item>
                          <Form.Item
                            label={
                              <strong
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  color: "grey",
                                }}
                              >
                                New Email ID
                              </strong>
                            }
                          >
                            <Input
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "black",
                                borderRadius: "10px",
                              }}
                              value={newEmail}
                              onChange={(e) => setNewEmail(e.target.value)}
                              placeholder="Enter new email ID"
                            />
                          </Form.Item>
                          {newEmail && (
                            <StyledButton
                              type="primary"
                              onClick={handleChangeEmail}
                              htmlType="submit"
                              icon={<ArrowRightOutlined />}
                              loading={buttonLoading}
                              style={{ marginRight: "8px" }}
                            >
                              Change Email
                            </StyledButton>
                          )}
                        </>
                      )}

                      {detailType === "Phone" && (
                        <>
                          <Form.Item
                            label={
                              <strong
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  color: "grey",
                                }}
                              >
                                Current Phone Number
                              </strong>
                            }
                          >
                            <Input
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "black",
                                borderRadius: "10px",
                              }}
                              value={phoneToChange || "Not set"}
                              disabled
                            />
                          </Form.Item>
                          <Form.Item
                            label={
                              <strong
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  color: "grey",
                                }}
                              >
                                New Phone Number
                              </strong>
                            }
                          >
                            <Input
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "black",
                                borderRadius: "10px",
                              }}
                              value={newPhone}
                              onChange={(e) => setNewPhone(e.target.value)}
                              placeholder="Enter 10-digit mobile number" maxLength={10}
                            />
                          </Form.Item>
                          {newPhone && (
                            <StyledButton
                              type="primary"
                              onClick={handleChangePhone}
                              htmlType="submit"
                              icon={<ArrowRightOutlined />}
                              loading={buttonLoading}
                              style={{ marginRight: "8px" }}
                            >
                              Change Phone
                            </StyledButton>
                          )}
                        </>
                      )}

                      {detailType === "Group" && (
                        <>
                          <Form.Item
                            label={
                              <strong
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  color: "grey",
                                }}
                              >
                                Current Group
                              </strong>
                            }
                          >
                            <Input
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "black",
                                borderRadius: "10px",
                              }}
                              value={groupToChange || "Not set"}
                              disabled
                            />
                          </Form.Item>
                          <Form.Item
                            label={
                              <strong
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "700",
                                  color: "grey",
                                }}
                              >
                                Select New Group
                              </strong>
                            }
                          >
                            <Select
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "black",
                                borderRadius: "10px",
                                width: "100%",
                              }}
                              placeholder="Select a group"
                              value={groupValue}
                              onChange={(value) => setGroupValue(value)}
                            >
                              {USER_GROUPS
                                .filter((group) => !groupToChange.startsWith(`${group.id} - `))
                                .map((group) => (
                                  <Option key={group.id} value={group.id}>
                                    {`${group.id} - ${group.name}`}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                          {groupValue && (
                            <StyledButton
                              type="primary"
                              onClick={handleChangeGroup}
                              htmlType="submit"
                              icon={<ArrowRightOutlined />}
                              loading={buttonLoading}
                              style={{ marginRight: "8px" }}
                            >
                              Change Group
                            </StyledButton>
                          )}
                        </>
                      )}
                    </Form>
                  </div>
                </Col>
              </Row>
            </div>
          </Modal>
        </div>
      </center>
    </>
  );
};

export default AddUSer;